import React from 'react';
import PropTypes from 'prop-types';
import { List, Set } from 'immutable';

import ImmutablePropTypes from 'react-immutable-proptypes';

function searchRole(role, string) {
    if (!string) {
        return true;
    }

    return (
        role.get('name').search(string) > 0
    );
}

class UserRolesList extends React.Component {
    static propTypes = {
        roles: ImmutablePropTypes.map.isRequired,
        user: ImmutablePropTypes.map,
        onRoleSelect: PropTypes.func,
        onRoleChange: PropTypes.func,
        editing: PropTypes.bool,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        onRoleSelect: () => {},
        onRoleChange: () => {},
        editing: false,
        disabled: false
    };

    constructor(props) {
        super(props);
        this.state = {
            newRoles: props.user ? Set(props.user.get('roles')) : Set()
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.user !== props.user) {
            this.setState({
                newRoles: props.user ? Set(props.user.get('roles')) : Set()
            });
        }
    }

    onQueryChange(e) {
        this.setState({ query: e.target.value });
    }

    onRoleChange(role, checked) {
        let { newRoles } = this.state;

        if (checked) {
            newRoles = newRoles.add(role);
        } else {
            newRoles = newRoles.delete(role);
        }

        this.props.onRoleChange(newRoles);

        this.setState({
            newRoles
        });
    }

    render() {
        let { roles, onRoleSelect, editing, disabled } = this.props;
        let { newRoles } = this.state;

        roles = roles.toList().sortBy(r => r.get('name'));

        return (
            <div className="user-roles">
                <input className="user-roles__input" type="text" onChange={ this.onQueryChange.bind(this)} />
                <ul className="user-roles__list">
                    {
                        roles.filter(r => searchRole(r, this.state.query)).map(
                            r => (
                                <li
                                    key={ r.get('id') } onClick={ () => onRoleSelect(r) }
                                >
                                    {
                                        editing ? (
                                            <input
                                                checked={ newRoles.has(r.get('id')) }
                                                disabled={ disabled }
                                                onChange={ e => this.onRoleChange(r.get('id'), e.target.checked) }
                                                type="checkbox"
                                                data-test={String(r.get('name')).replaceAll(' ', '-').toLowerCase()}
                                            />
                                        ) : void 0
                                    }
                                    <span className="user-roles-list__role">
                                        { r.get('name') }
                                    </span>
                                </li>
                            )
                        )
                    }
                </ul>
            </div>
        );
    }
}

export default UserRolesList;
